import React, { useEffect, useRef, useState } from 'react';
import { Alert } from '30pay/components';
import { CardNumbers } from './card/card.index';
import IBans, { IBansRef } from './iBan/iBan.index';
import { hasFirstTimeBankAccountVideoSeen } from 'scripts';
import { FirstTimeVideoModal } from '30pay/components/firstTimeVideoModal/firstTimeVideoModal.index';

export const BankAccounts = () => {
    const iBanRef = useRef<IBansRef>(null);
    const [isFirstTimeVideoOpen, setIsFirstTimeVideoOpen] = useState<boolean>(false);

    useEffect(() => {
        if (hasFirstTimeBankAccountVideoSeen.get()) {
            setIsFirstTimeVideoOpen(false);
        } else {
            setIsFirstTimeVideoOpen(true);
            hasFirstTimeBankAccountVideoSeen.set(true);
        }
    }, []);
    return (
        <div className="p-4 w-full h-full flex flex-col gap-6">
            <FirstTimeVideoModal
                title="آموزش ثبت کارت های بانکی"
                src="http://new.30pay.me/media/firstTime-bankAccount-video.mp4"
                isOpen={isFirstTimeVideoOpen}
                onClose={() => setIsFirstTimeVideoOpen(false)}
            />
            <Alert variant="info" message="مشخصات بانکی باید به نام باشد و در غیر این صورت تأیید نمی‌شود." />
            <div className="flex items-start gap-6 max-[1220px]:flex-col w-full">
                <CardNumbers reload={() => iBanRef.current?.getData()} />
                <IBans ref={iBanRef} />
            </div>
        </div>
    );
};
